import { render, staticRenderFns } from "./InputTextNumber.vue?vue&type=template&id=6aeda0f3&scoped=true"
import script from "./InputTextNumber.vue?vue&type=script&lang=js"
export * from "./InputTextNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeda0f3",
  null
  
)

export default component.exports